/*
  Motureo (W1): czyste funkcje interakcji — bez DOM i bez zależności, testowane w Node
  (tests/test_rozbudowa_interakcje.py uruchamia tests/js/motureo-logika.test.js).
  W przeglądarce zwykły skrypt (defer) przed modułami motureo-menu.js i motureo-product.js;
  funkcje są w globalThis.MotureoLogika (także w Node, gdzie theme/assets/package.json z Horizona każe ładować
  plik jako moduł ES), a w środowisku CommonJS dodatkowo w module.exports.

  - isOeQuery: czy wpis wygląda na numer OE — ta sama reguła co w sections/predictive-search.liquid
    (5–40 znaków po obcięciu spacji, tylko a–z, 0–9, „-” i „.”, co najmniej jedna cyfra).
  - normalizeOe / findOe: porównanie numeru klienta z listą numerów z metapola motureo.oe_numbers.
  - normalizeText: porównanie wpisu w filtrze menu bez wielkości liter i znaków diakrytycznych.
  - categoryEntries: kategorie rodziny w języku strony; jednakowe nazwy z różnymi adresami dostają
    w title nazwę polską (żeby dwa takie same odnośniki dało się rozróżnić); w wersji bg adres z handle_bg.
  - familyHandle: adres kolekcji rodziny w języku strony (w wersji bg z handle_bg) albo null.
  - addRecent / visibleRecent: lista „ostatnio oglądane” (maks. 8, bez bieżącego produktu, tylko w języku strony).
*/
(function (root) {
  const OE_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789-.';
  const OE_MIN = 5;
  const OE_MAX = 40;
  const RECENT_LIMIT = 8;

  function isOeQuery(value) {
    const text = String(value || '').trim().toLowerCase();
    if (text.length < OE_MIN || text.length > OE_MAX) return false;
    let digit = false;
    for (const char of text) {
      if (!OE_CHARS.includes(char)) return false;
      if (char >= '0' && char <= '9') digit = true;
    }
    return digit;
  }

  function normalizeOe(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[\s.\-]+/g, '');
  }

  /** Numer z listy (w zapisie z danych) zgodny z wpisem klienta albo null. */
  function findOe(input, numbers) {
    const wanted = normalizeOe(input);
    if (!wanted || !Array.isArray(numbers)) return null;
    for (const number of numbers) {
      if (normalizeOe(number) === wanted) return String(number);
    }
    return null;
  }

  function normalizeText(text) {
    return String(text || '')
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l')
      .trim();
  }

  /** [{label, title, handle}] dla kategorii rodziny z motureo-menu.json w języku lang ('bg' albo 'pl').
      W wersji bg adres z handle_bg (przetłumaczony adres kolekcji), bo adres podstawowy działa tam tylko przez 301. */
  function categoryEntries(categories, lang) {
    const list = Array.isArray(categories) ? categories : [];
    const key = lang === 'bg' ? 'bg' : 'pl';
    const counts = new Map();
    for (const c of list) counts.set(c[key], (counts.get(c[key]) || 0) + 1);
    return list.map((c) => ({
      label: c[key],
      title: counts.get(c[key]) > 1 && key !== 'pl' ? `${c[key]} (${c.pl})` : '',
      handle: (key === 'bg' && c.handle_bg) || c.handle,
    }));
  }

  /** Adres kolekcji rodziny w języku lang albo null (rodzina bez własnej kolekcji). */
  function familyHandle(family, lang) {
    if (!family || !family.handle) return null;
    return (lang === 'bg' && family.handle_bg) || family.handle;
  }

  const isProduct = (p) => Boolean(p) && typeof p.handle === 'string' && p.handle !== '';

  /** Nowa lista po obejrzeniu produktu: na początek, bez powtórzeń, maks. 8. */
  function addRecent(list, product) {
    const rest = (Array.isArray(list) ? list : []).filter((p) => isProduct(p) && p.handle !== product.handle);
    return [product, ...rest].slice(0, RECENT_LIMIT);
  }

  /** Pozycje do pokazania: bez bieżącego produktu i tylko zapisane w języku strony (stare wpisy bez języka też). */
  function visibleRecent(list, current, locale) {
    return (Array.isArray(list) ? list : []).filter(
      (p) => isProduct(p) && p.handle !== current && (!p.locale || !locale || p.locale === locale)
    );
  }

  const api = { isOeQuery, normalizeOe, findOe, normalizeText, categoryEntries, familyHandle, addRecent, visibleRecent, RECENT_LIMIT };
  root.MotureoLogika = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
